import {
  DoorOpen, DoorClosed, Archive, AirVent, Fan, Toilet, ShowerHead, Bath, GlassWater, SprayCan, RectangleVertical,
  BedDouble, Armchair, Sofa, Lightbulb, LampFloor, Tv, Plug, Blinds, AppWindow, Shirt, Lock, Key, Waves, Umbrella,
  Sun, Droplets, Trees, Flower2, Refrigerator, Microwave, CookingPot, Utensils, WashingMachine, Wifi, Heater,
  Grid3x3, Fence, Speaker, Table, Frame,
} from "lucide-react";

const COMMON = [
  ["Πόρτες", DoorOpen], ["Παράθυρα", AppWindow], ["Κλιματιστικό", AirVent], ["Ανεμιστήρας οροφής", Fan],
  ["Φωτισμός", Lightbulb], ["Πρίζες / Διακόπτες", Plug], ["Κουρτίνες / Blinds", Blinds],
];

const TOUCHPOINTS = {
  bedroom: [
    ...COMMON, ["Ντουλάπες", Archive], ["Κρεβάτι", BedDouble], ["Στρώμα / Λευκά είδη", Shirt], ["Καρέκλα", Armchair],
    ["Τηλεόραση", Tv], ["Χρηματοκιβώτιο", Key], ["Κλειδαριά", Lock], ["Τουαλέτα", Toilet], ["Ντους", ShowerHead],
    ["Τζάμι ντους", GlassWater], ["Μπανιέρα", Bath], ["Νιπτήρας / Βρύση", Droplets], ["Dispenser amenities", SprayCan],
    ["Καθρέφτης", RectangleVertical], ["Δάπεδο", Grid3x3], ["Άλλο", Frame],
  ],
  living: [
    ...COMMON, ["Καναπές", Sofa], ["Πολυθρόνα", Armchair], ["Τραπέζι", Table], ["Τηλεόραση", Tv], ["Ηχείο", Speaker],
    ["WiFi", Wifi], ["Φωτιστικό δαπέδου", LampFloor], ["Ψυγείο", Refrigerator], ["Φούρνος μικροκυμάτων", Microwave],
    ["Εστίες / Μαγειρικά", CookingPot], ["Σκεύη", Utensils], ["Πλυντήριο", WashingMachine], ["Θέρμανση", Heater],
    ["Δάπεδο", Grid3x3], ["Κλειδαριά", Lock], ["Άλλο", Frame],
  ],
  pool: [
    ["Νερό πισίνας", Waves], ["Αντλία / Φίλτρο", Droplets], ["Φωτισμός πισίνας", Lightbulb], ["Ξαπλώστρες", Armchair],
    ["Ομπρέλες", Umbrella], ["Εξωτερικό ντους", ShowerHead], ["Πλακάκια / Δάπεδο", Grid3x3], ["Κάγκελα / Περίφραξη", Fence],
    ["Φυτά / Κήπος", Flower2], ["Δέντρα", Trees], ["Εξωτερικός φωτισμός", Sun], ["Πόρτα / Πύλη", DoorClosed],
    ["Έπιπλα εξωτερικού", Table], ["Άλλο", Frame],
  ],
};

export const areaType = (area) => (/pool/i.test(area) ? "pool" : /living/i.test(area) ? "living" : "bedroom");
export const touchpoints = (area) => TOUCHPOINTS[areaType(area)];
export const touchIcon = (area, item) => (touchpoints(area).find(([l]) => l === item) || [null, Frame])[1];
